import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import PropTypes from "prop-types";
import { StyledInput, InputContainer } from "./searchInput.styles";
import { Flex } from "@base-ui/containers";
import { Label } from "@base-ui/text";
import { useInput } from "hooks";
import { extendedSystemStylesProps } from "@mixins";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var styledSystemKeys = ["space", "layout", "flexbox"];
var SearchInput = function SearchInput(props) {
  var id = props.id,
    value = props.value,
    label = props.label,
    search = props.search,
    placeholder = props.placeholder,
    disabled = props.disabled,
    hideLabel = props.hideLabel,
    autoFocus = props.autoFocus,
    _onBlur = props.onBlur,
    maxLength = props.maxLength,
    _onFocus = props.onFocus,
    title = props.title,
    icon = props.icon,
    className = props.className,
    searchRef = props.searchRef,
    inverted = props.inverted,
    error = props.error,
    errorMessage = props.errorMessage,
    ariaControls = props.ariaControls,
    ariaAutocomplete = props.ariaAutocomplete,
    ariaActivedescendant = props.ariaActivedescendant,
    ariaHasPopup = props.ariaHasPopup;
  var _useInput = useInput(value, search),
    inputString = _useInput.inputString,
    onInput = _useInput.onInput;
  return /*#__PURE__*/_jsxs(Flex.Column, _objectSpread(_objectSpread({
    role: "search",
    className: className
  }, extendedSystemStylesProps(styledSystemKeys, props)), {}, {
    children: [/*#__PURE__*/_jsx(Label, {
      id: "".concat(id, "-label"),
      htmlFor: id,
      hideLabel: !error && hideLabel,
      inverted: inverted,
      disabled: disabled,
      children: error && errorMessage ? errorMessage : label
    }), /*#__PURE__*/_jsx(InputContainer, {
      disabled: disabled,
      icon: icon,
      inverted: inverted,
      children: /*#__PURE__*/_jsx(StyledInput, {
        id: id,
        ref: searchRef,
        type: "search",
        name: "search",
        error: error,
        "aria-controls": ariaControls || undefined,
        "aria-autocomplete": ariaAutocomplete || undefined,
        "aria-activedescendant": ariaActivedescendant || undefined,
        "aria-haspopup": ariaHasPopup || undefined,
        value: inputString,
        autoFocus: autoFocus,
        autoComplete: "off",
        onFocus: function onFocus(e) {
          return _onFocus && _onFocus(e);
        },
        onBlur: function onBlur(e) {
          return _onBlur && _onBlur(e);
        },
        onChange: function onChange(e) {
          return onInput(e.target.value);
        },
        placeholder: placeholder,
        disabled: disabled,
        title: title,
        maxLength: maxLength,
        inverted: inverted
      })
    })]
  }));
};
SearchInput.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  search: PropTypes.func.isRequired,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  hideLabel: PropTypes.bool,
  autoFocus: PropTypes.bool,
  maxLength: PropTypes.number,
  inverted: PropTypes.bool,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  icon: PropTypes.string,
  className: PropTypes.string,
  searchRef: PropTypes.any,
  error: PropTypes.bool,
  title: PropTypes.string
};
export default SearchInput;